module.exports = require('nanohtml/raw');